import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ResolvableServiceUsage_Update_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ResolvableServiceUsage_Update(
      $serviceUsageId: Id!
      $serviceUserId: Id!
      $serviceUsagesGroupId: Id!
      $update: ResolvableServiceUsageInput!
      $versionData: VersionDataInput
    ) {
      updateMissionServiceUsage(
        serviceUsageId: $serviceUsageId
        serviceUserId: $serviceUserId
        serviceUsagesGroupId: $serviceUsagesGroupId
        update: $update
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useUpdateMissionResolvableServiceUsageMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ResolvableServiceUsage_Update_Mutation,
  );
